import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { BasicModalComponent, BasicModalResult } from 'app/components/modal/basicModal.component';
import { ModalService } from 'app/services/modal.service';

export interface PendingChangesAware {
    hasPendingChanges(): boolean | Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<PendingChangesAware> {

    constructor(private modal: ModalService) { }

    public async canDeactivate(component: PendingChangesAware) {
        if (!await this.isDirty(component)) { return true; }

        let result = await this.modal.open<BasicModalComponent, BasicModalResult>(BasicModalComponent, {
            icon: 'exclamation-triangle',
            resourcePath: 'components.guards.pending-changes'
        });

        switch (result) {
            case BasicModalResult.Dismiss:
            case BasicModalResult.PrimaryAction:
                return false;
            case BasicModalResult.SecondaryAction:
                return true;
        }
    }

    private async isDirty(component: PendingChangesAware) {
        let isDirty = component.hasPendingChanges();
        return typeof isDirty === 'boolean' ? isDirty : await isDirty;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/guards/pendingChanges.guard.ts